import { BrowserRouter, Route, Routes,Navigate,Outlet  } from 'react-router-dom';
import Logo from './SmartEvacLogo.jpg';

/// Login/ Register user files
import {auth} from './Login/Firebase.js';
import Login from './Login/Login';
import Register from './Login/Register'; 
import FailedAttempts from './Login/FailedAttempts';
import Registered from './Login/Registered'; 

/// Homepage/ Adminpage files
import AdminPage from './Home/AdminPage';
import IssueMessage from './Home/IssueMessage';  

/// Evacuation Procedure files
import Start from './EvacuationProcedure/Start'; 
import Disabled from './EvacuationProcedure/Disabled'; 
import End from './EvacuationProcedure/End';
import Emergency from './EvacuationProcedure/Emergency';

/// Add Person files
import AddPerson from './Add/AddPerson';
import AddPersonOption from './Add/AddPersonOption';
import AddPersonTemp from './Add/AddPersonTemp';
import AddedPerson from './Add/AddedPerson';
import Bulkupload from './Add/BulkAddition.js';

/// Search Person files
import SearchPerson from './Search/SearchPerson';

/// Emergency Plan files
import EmergencyPlan from './Plan/EmergencyPlan';

/// Remove Person files
import Remove from './Remove/Remove';
import RemovePersonOption from './Remove/RemovePersonOption';
import RemoveTemp from './Remove/RemoveTemp';
import RemovedPerson from './Remove/RemovedPerson';


/// Modify Person files
import Modify from './Modify/Modify';
import ModifiedPerson from './Modify/ModifiedPerson';


const PrivateRoutes = () => (auth.currentUser ? <Outlet /> : <Navigate to="/" />);

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route element={<PrivateRoutes/>}>
            <Route path="/adminpage" element={<AdminPage />} />
            <Route path="/addperson" element={<AddPerson />} />
            <Route path="/start" element={<Start />} />
            <Route path="/disabled" element={<Disabled />} />
            <Route path="/addPersonOption" element={<AddPersonOption />} />
            <Route path="/addPersonTemp" element={<AddPersonTemp />} />
            <Route path="/searchPerson" element={<SearchPerson />} />
            <Route path="/end" element={<End />} />
            <Route path="/modify" element={<Modify />} />
            <Route path="/bulkupload" element={<Bulkupload />} />
            <Route path="/remove" element={<Remove />} />
            <Route path="/emergency" element={<Emergency />} />
            <Route path="/addedPerson" element={<AddedPerson />} />
            <Route path="/emergencyPlan" element={<EmergencyPlan />} />
            <Route path="/removePersonOption" element={<RemovePersonOption />} />
            <Route path="/removeTemp" element={<RemoveTemp />} />
            <Route path="/modifiedPerson" element={<ModifiedPerson />} />
            <Route path="/removedPerson" element={<RemovedPerson />} />
            <Route path="/issuemessage" element={<IssueMessage />} />
          </Route>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/registered" element={<Registered />} />
          <Route path="/failedAttempts" element={<FailedAttempts />} />
        </Routes>
      </BrowserRouter>
      <footer className='footer'>
        <p>
          <img src={Logo} width="220" height="30" alt="SmartEvac Logo" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span>Contact: smartevac.co.uk@gmail.com</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span>Created by Adam Beji</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span>© 2025 SmartEvac. All rights reserved.</span>
        </p>
      </footer>
    </div>
  );
}

export default App;

